import {Icon, IconProps} from '@chakra-ui/react';

export const TargetIcon = (props: IconProps) => (
  <Icon width="21px" height="21px" viewBox="0 0 21 21" fill="none" color="white" {...props}>
    <path
      d="M10.4854 13.5C12.1422 13.5 13.4854 12.1569 13.4854 10.5C13.4854 8.84315 12.1422 7.5 10.4854 7.5C8.8285 7.5 7.48535 8.84315 7.48535 10.5C7.48535 12.1569 8.8285 13.5 10.4854 13.5Z"
      fill="currentColor"
    />
    <path
      d="M20.4854 9.5H18.4164C17.9624 5.888 15.0974 3.023 11.4854 2.569V0.5H9.48535V2.569C5.87435 3.023 3.00835 5.888 2.55435 9.5H0.485352V11.5H2.55435C3.00835 15.112 5.87335 17.978 9.48535 18.431V20.5H11.4854V18.431C15.0974 17.977 17.9624 15.112 18.4164 11.5H20.4854V9.5ZM10.4854 16.5C7.17635 16.5 4.48535 13.808 4.48535 10.5C4.48535 7.192 7.17635 4.5 10.4854 4.5C13.7944 4.5 16.4854 7.192 16.4854 10.5C16.4854 13.808 13.7944 16.5 10.4854 16.5Z"
      fill="currentColor"
    />
  </Icon>
);
